export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },
  admins_logs: {
    admins_logs: "/admins-logs",
  },
  settings: {
    settings: "/settings",
    legal_information: "/legal_information",
  },
  slideshow: "/slideshow",
  home_sections: "/home-sections",
  statistics: "/statistics",
  executive_committee: "/executive-committee",
  general_commission: "/general-commission",
  sections: "/sections",
  ourTeam: "/our-team",
  contact_locations: "/contact-locations",
  locate_us: "/locate-us",
  media_posts: "/media-posts",
  sponsors: "/sponsors",
  formations: "/formations",
  media: "/media/:type/:related_id",
  galleries: "/galleries/:type/:related_id",
  gallery_items: "/gallery-items/:gallery_id",
  home: "/dashboard",
};
